/**
 * @description: 自定义曲库管理
 * @author: lyr
 * @update: wgt
 */
<template>
	<div class="custom_music_manage_wrap">
		<div class="music-list" v-show="showList">
            <h1>自定义曲库管理</h1>
            <p>注： 注： 1 曲库列表变更后，需操作“打包上传”，上传成功后，重启机顶盒即可生效；2 打包上传歌曲操作只在08：00-18：00期间开放；3 仅支持P950及以上的安卓机顶盒</p>
            <el-form :inline="true" :model="list_form">
				<el-form-item label="歌星">
					<el-input v-model="list_form.szPlayer" placeholder="请输入歌星名称"></el-input>
				</el-form-item>
				<el-form-item label="歌曲">
					<el-input v-model="list_form.szSong_name" placeholder="请输入歌曲名称"></el-input>
				</el-form-item>
				<el-form-item class="pull-right">
					<el-button type="primary" @click="openCustomPlayerList">自定义歌星列表</el-button>
					<el-button type="primary" @click="packageUpload">打包上传</el-button>
					<el-button type="primary" @click="listQuery">查询</el-button>
					<el-button type="primary" @click="toAdd">新增歌曲</el-button>
				</el-form-item>
			</el-form>
			<div class="row row-margin">最新歌库版本：{{new_version}}</div>
            <el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="list_table">
				<el-table-column prop="szPlayerStr" label="歌星"></el-table-column>
				<el-table-column prop="szSong_name" label="歌曲"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
                        <span class="text-blue" @click="toModify(scope.row)">修改</span>
						<span class="text-blue" @click="deleteThis(scope.row.id)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="list_page"
				:total="list_total"
				@current-change="getListTable">
			</el-pagination>
		</div>
		<div class="add-panel" v-show="showAdd">
			<h1>{{isModify?'修改歌曲':'新增歌曲'}}</h1>
			<el-form v-model="add_form" label-width="120px">
                <el-form-item label="语言">
                    <el-select v-model="add_form.szLanguage" placeholder="请选择歌曲所属语言">
				      	<el-option :label="item.name" :value="item.name" :key="item.id" v-for="item in szLanguage_list"></el-option>
				    </el-select>
                </el-form-item>
                <el-form-item label="灯光分类">
                   	<el-select v-model="add_form.lighting" placeholder="请选择灯光分类">
				      	<el-option :label="item.name" :value="item.name" :key="item.id" v-for="item in lighting_list"></el-option>
				    </el-select>
				    <span class="rmarkspan" titles="灯光分类标准：</br>A 空白 B 迪斯科 C 打碟 D 华尔兹   E 四拍舞曲   F 探戈   G 恰恰、伦巴、慢摇   H 心痛   I 伤感   J 舒服   K 欢快   L 激情   M 励志   N 怀旧   O 摇滚   P R&B   Q Hip-Pop   R 电子   S 爵士   T 蓝调、美声   U 乡村、民谣   V 生日   W 民歌、民族   X 戏曲   Y 儿歌   Z 喜庆    " @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
                </el-form-item>
                <el-form-item label="歌曲名称">
                   	<el-input v-model="add_form.szSong_name" clearable placeholder="请输入歌曲名称"></el-input>
                </el-form-item>
                <el-form-item label="歌星名称">
                   	<el-input v-model="add_form.szPlayerStr" placeholder="请选择歌星名称" readonly @click.native="openPlayerPanel"></el-input>
                </el-form-item>
                <el-form-item label="歌星分类">
                   	<el-select v-model="add_form.szPlayerClass" placeholder="请选择歌星分类" filterable>
				      	<el-option :label="item.name" :value="item.name" :key="item.id" v-for="item in szPlayerClass_list"></el-option>
				    </el-select>
                </el-form-item>
                <el-form-item label="歌曲文件">
                   	<el-input v-model="add_form.file_url" placeholder="请上传歌曲文件" readonly></el-input>
                   	<el-button type="primary" class="upload-btn" id="upload-btn">上传歌曲文件</el-button>
                   	<div class="warm-tip">上传歌曲格式需为：mkv/mp4/avi，仅支持H.264编码的文件，如上传格式不符合将无法正常播放，歌曲分辨率不能超过1080p，单个文件大小不能超过500m。</div>
                </el-form-item>
				<el-form-item>
                    <el-button @click="backToList">取消</el-button>
                    <el-button type="primary" @click="onConfirmClick">确定</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 歌星面板 -->
        <div class="player-panel" ref="player_panel">
        	<el-row class="inline center">
				<el-input class="search-input" placeholder="检索输入歌星名称" prefix-icon="el-icon-search" clearable v-model="name"></el-input>
				<el-button type="primary" @click="playerQuery" class="query-btn">查询</el-button>
        	</el-row>
        	<el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="player_list">
				<el-table-column prop="name" label="歌星"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
                        <el-checkbox :value="scope.row.checked" @change="checkedPlayer(scope.row)"></el-checkbox>
					</template>
				</el-table-column>
				<template slot="empty">
					<div>未找到歌星"{{name}}"，<span class="text-blue cursor-pointer" @click="quickAddSinger">立即添加</span>该歌星到自定义歌星列表</div>
				</template>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="player_page"
				:total="player_total"
				@current-change="getPlayerTable">
			</el-pagination>
        </div>

		<!-- 自定义歌星列表 -->
		<div class="custom-player-list" v-show="showCustomPlayerList">
			<h1>自定义歌星列表</h1>
			<el-form :inline="true" :model="custom_player_list_form">
				<el-form-item label="歌星">
					<el-input v-model="custom_player_list_form.szName" placeholder="请输入歌星名称" clearable></el-input>
				</el-form-item>
				<el-button type="primary" @click="getCustomPlayerList(1)">查询</el-button>
				<el-button type="primary" @click="toAddCustomPlayer">新增歌星</el-button>
				<el-button @click="backToList">返回</el-button>
			</el-form>
			<el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="custom_player_list_table">
				<el-table-column prop="szName" label="歌星"></el-table-column>
                <el-table-column prop="szPlayerClass" label="歌星分类"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
                        <span class="text-blue" @click="editCustomPlayer(scope.row)">修改</span>
						<span class="text-blue" @click="deleteCustomPlayer(scope.row.id)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="custom_player_list_page"
				:total="custom_player_list_total"
				@current-change="getCustomPlayerList">
			</el-pagination>
		</div>
		<!-- 新增歌星弹窗 -->
		<div class="add-singer-pop ele-hide" ref="add_singer_pop">
			<el-form>
				<el-form-item label="歌星名称">
					<el-input v-model="add_custom_player_szName" placeholder="请输入歌星名称" clearable></el-input>
				</el-form-item>
                <el-form-item label="歌星分类">
                    <el-select 
                        v-model="add_custom_player_szPlayerClass" 
                        placeholder="请选择歌星分类" 
                        filterable
                        clearable
                        filter-method="filterPlayerClass"
                        @filter-change="onFilterChange"
                        @change="onPlayerClassChange">
                        <el-option 
                            :label="item.name" 
                            :value="item.name" 
                            :key="item.id" 
                            v-for="item in filteredPlayerClassList">
                        </el-option>
                    </el-select>
                </el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				showList: true,
				showAdd: false,
                loading: false,
                list_form: {
	                szPlayer: '',
	                szSong_name: '',
                },
                list_page: 1,
				list_total: 0,
                list_table: [],
                new_version: '',

                add_form: {
                	id: '',
		            szSong_name: '', //歌曲名称
		            file_url: '', //文件地址
		            szPlayer: [],
		            szPlayerStr: '', // 歌星字符串显示
		            szLanguage: '', //语言
		            lighting: '', //灯光分类
		            szPlayerClass: '' //歌星分类
                },
                hasLoaded: false, // 是否已经请求过分类参数
                szLanguage_list: [], // 语言分类
                lighting_list: [], // 灯光分类
                szPlayerClass_list: [], // 歌星分类

                isModify: false,

                name: '', // 搜索歌星名
                player_page: 1,
                player_page_size: 7,
                player_total: 0,
                player_list: [],
                player_choose: [], // 选择的歌星

				showCustomPlayerList: false,
				custom_player_list_form: {
					szName: ''
				},
				custom_player_list_page: 1,
				custom_player_list_total: 0,
				custom_player_list_table: [],
				add_custom_player_szName: '',
                add_custom_player_szPlayerClass: '',
                custom_player_class_list: [], // 自定义歌星分类
                filteredPlayerClassList: [], // 过滤后的歌星分类列表
			}
		},
        created: function() {
			
		},
		mounted: function() {
			this.getListTable(1);
			this.openUpdsongs()
			this.getCustomPlayerClass()
		},
		methods: {
			// 列表
			getListTable: function(page) {
				const _this = this;

				_this.loading = true;
				_this.list_page = page;
				Vue.axios.post('Songs/getCustomSongsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"szSong_name": _this.list_form.szSong_name,
							"szPlayer": _this.list_form.szPlayer
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total);
						}
						if (res.data.response.result.rows.length > 0) {
							res.data.response.result.rows.forEach((item, index) => {
								if (item.szPlayer.length > 0) {
									item.szPlayerStr = item.szPlayer.join(",")
								}
							})
						}
						_this.list_table = res.data.response.result.rows;
						_this.new_version = res.data.response.result.new_version.version;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 查询
			listQuery() {
				this.getListTable(1);
            },

            // 获取曲库字段配置取值
            getConfig: function(key) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('PublicData/api_getSongsFieldConfig', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"key": key
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						console.log(res.data.response.data)
						_this[`${key}_list`] = res.data.response.data
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            // 点击“修改”
            toModify(row) {
            	this.isModify = true
            	this.add_form = JSON.parse(JSON.stringify(row))
            	this.showAdd = true
            	this.showList = false
            	if (!this.hasLoaded) {
	            	this.getConfig('szLanguage') // 语言
	            	this.getConfig('lighting') // 灯光
	            	this.getConfig('szPlayerClass') // 歌星分类
	            	this.hasLoaded = true
            	}
            },

            // 点击新增/修改的“确定”
            onConfirmClick() {
            	const _this = this;
            	let requestUrl = 'Songs/addCustomSongs'
            	if (this.isModify) {
            		requestUrl = 'Songs/editCustomSongs'
            	}
				Vue.axios.post(requestUrl, {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": _this.add_form.id || null,
				            "szSong_name": _this.add_form.szSong_name, //歌曲名称
				            "file_url": _this.add_form.file_url, //文件地址
				            "szPlayer": _this.add_form.szPlayer, //歌手信息 歌手是可以选择多个的，最多给可以选择2个
				            "szLanguage": _this.add_form.szLanguage, //语言
				            "lighting": _this.add_form.lighting, //灯光分类
				            "szPlayerClass": _this.add_form.szPlayerClass, //歌星分类
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						if (_this.isModify) {
							_this.getListTable(_this.list_page);
						}else {
							_this.getListTable(1);
						}
						_this.showList = true;
						_this.showAdd = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },

            // 搜索歌星
            playerQuery() {
            	this.player_page = 1
            	this.player_list = []
            	this.player_total = 0
            	this.getPlayerTable(this.player_page)
            },

            openPlayerPanel() {           	
            	this.player_choose = []
            	this.name = ''
            	this.playerQuery()
            	let _this = this;

				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: ['请选择歌星名称', true],
					area: ['700px', '630px'],
					content: $(_this.$refs.player_panel),
					offset: '100px'
				}, function() {
					if (_this.player_choose.length < 1) {
						layer.msg("请选择歌星")
						return
					}else {
						_this.add_form.szPlayer = []
						_this.player_choose.forEach(item => {
							_this.add_form.szPlayer.push(item.name)
						})
						_this.add_form.szPlayerStr = _this.add_form.szPlayer.join(",")
						layer.closeAll()
					}
				});
            },

            // 歌星列表
            getPlayerTable(page) {
            	const _this = this;

				_this.loading = true;
				_this.player_page = page;
				Vue.axios.post('PublicData/api_getSingerList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.player_page_size,
							"name": _this.name,
							"get_custom_songs": 1, // 是否需要取商家自定义歌手列表
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.player_total = Number(res.data.response.data.total);
						}
						if (res.data.response.data.rows.length > 0) {
							let list = []
							res.data.response.data.rows.forEach(item => {
								if (_this.add_form.szPlayer.indexOf(item.name) > -1) {
									item.checked = true
									_this.player_choose.push(item)
								}else {
									item.checked = false
								}
								list.push(item)
								_this.player_list = list
							})
						}
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },


            // 选择歌手
            checkedPlayer(row) {
            	let listIndex = this.player_list.findIndex(item => item.id == row.id)

            	if (!row.checked) { // 选中
            		if (this.player_choose.length >= 2) {
            			layer.msg("最多可选择两个歌星")
            			this.player_list[listIndex].checked = false
            		}else {
            			console.log("选中：", listIndex)
            			this.player_list[listIndex].checked = true
            			this.player_choose.push(row)
            		}
            	}else { // 取消
            		let index = this.player_choose.findIndex(item => item.id == row.id)
            		
            		if (index > -1) {
            			this.player_choose.splice(index, 1)
            			this.player_list[listIndex].checked = false
            		}
            	}
            },

            // 歌曲文件上传
			openUpdsongs: function() {
				const _this = this;
				let host = '',
					dir = '',
					file_name = '';

				let layIndex;
				// 实例化一个plupload上传对象
				let uploader = new plupload.Uploader({
					browse_button: 'upload-btn', // 选择文件id
					filters: {
						mime_types: [ // 文件格式限制
							{ title: "files", extensions: "mp4,mkv,mpg" }
						],
						max_file_size: '600mb', // 文件大小限制
						// prevent_duplicates: true // 不允许选取重复文件
					},
					multi_selection: false, // 单选
					url: "./", // OSS地址
					init: {
						// 文件上传前触发
						BeforeUpload: function(up, file) {
							layIndex = layer.load(2, {
								shade: [0.1, '#ececec']
							});
							// 获取签名
							let datas = {
								"header": Vue.request_header,
								"request": {
									"version": Vue.version,
									"param": {}
								},
								"comment": ""
							};
							let datas2 = JSON.stringify(datas);
							$.ajax({
								type: "POST",
								dataType: "json",
								url: Vue.ctUrl + "Songs/getCustomSongsOssSignature",
								async: false,
								crossDomain: true,
								xhrFields: {
									withCredentials: true
								},
								data: datas2,
								success: function(data) {
									if(data.response.result_code == "true") {
										host = data.response.result.signature.host;
										dir = data.response.result.signature.dir;
										
										let param = {
					                        "header": Vue.request_header,
					                        "request": {
					                            "param": {
					                                'file': file.name
					                            }
					                        },
					                        "comment": ""
					                    };
					                    let params = JSON.stringify(param);
					                    $.ajax({
					                        type: "POST",
					                        dataType: "json",
					                        url: Vue.ctUrl + "Songs/getCustomSongsFileName",
					                        async: false,
					                        crossDomain: true,
					                        xhrFields: {
					                            withCredentials: true
					                        },
					                        data: params,
					                        success: function(res) {
					                            if(res['response']['result_code'] == "true") {
					                            	file_name = res.response.result.file_name
					                               	let new_params = {
														'key': dir + file_name,
														'OSSAccessKeyId': data.response.result.signature.accessid,
														'policy': data.response.result.signature.policy,
														'signature': data.response.result.signature.signature,
														'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
													};
													up.setOption({
														'url': host,
														'multipart_params': new_params
													});
					                            } else {
					                                Vue.timeoutfun(res.response.result_status, _this);
					                                layer.msg(res["response"]["error_msg"]);
					                            }
					                        },
					                        error: function(err) {
					                        	layer.msg("出错啦");
					                        }
					                    });
										
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								},
								error: function(err) {
									layer.msg("出错啦");
								}
							});
						},
						// 文件选择完毕触发
						FilesAdded: function(up, file) {
							// 上传文件
							uploader.start();
						},
						// 文件上传成功触发
						FileUploaded: function(up, file, data) {
							// _this.edit_file_name = file.name;
							_this.add_form.file_url = host + "/" + dir + file_name;
							layer.close(layIndex);
							layer.msg('上传成功');
						},
						// 错误提示
						Error: function(up, err) {
							if(err.code == -600) {
								layer.msg('请选择2mb以内的文件');
							} else if (err.code == -601) {
								layer.msg('只允许上传mp4,mkv,mpg文件');
							} else if (err.code == -602) {
								layer.msg('这个文件已经上传过一遍了');
							} else {
								layer.msg(err.message);
							}
						}
					}
				});
				// 初始化
				uploader.init();
			},

            // 删除
            deleteThis(id) {
            	const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Songs/delCustomSongs', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getListTable(_this.list_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },

            // 打包
            packageUpload() {
            	const _this = this;

				_this.loading = true;
				Vue.axios.post('Songs/upCustomSongsPack', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					_this.loading = false;
					if(res.data.response.result_code == "true") {
						layer.msg(res.data.response.error_msg);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },

            // 新增
            toAdd() {
            	this.add_form = {
		            szSong_name: '', //歌曲名称
		            file_url: '', //文件地址
		            szPlayer: [],
		            szPlayerStr: '',
		            szLanguage: '', //语言
		            lighting: '', //灯光分类
		            szPlayerClass: '' //歌星分类
                }
                this.showList = false
            	this.showAdd = true
            	this.isModify = false
            	if (!this.hasLoaded) {
	            	this.getConfig('szLanguage') // 语言
	            	this.getConfig('lighting') // 灯光
	            	this.getConfig('szPlayerClass') // 歌星分类
	            	this.hasLoaded = true
            	}
            },

            backToList() {
            	this.showList = true
            	this.showAdd = false
				this.showCustomPlayerList = false
            },

            hint_language: function(e) {
				var contents = "<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
				layer.tips(contents,$(e.currentTarget),{
					skin: 'hint_language_tip',
					tips: [2, '#fff'],
					time: 2000000,
				});
			},
			// 关闭提示语
			close_hint_language: function() {
				layer.closeAll('tips');
			},

			openCustomPlayerList() {
				this.showList = false
				this.showCustomPlayerList = true
				this.getCustomPlayerList(1)
			},
            // 获取自定义歌星分类
            getCustomPlayerClass() {
                Vue.axios.post('PublicData/api_getSongsFieldConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "key": "szPlayerClass"
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        this.custom_player_class_list = res.data.response.data
                        this.filteredPlayerClassList = [...this.custom_player_class_list]
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 过滤歌星分类
            filterPlayerClass(query) {
                if (query !== '') {
                    this.filteredPlayerClassList = this.custom_player_class_list.filter(item => {
                        return item.name.toLowerCase().includes(query.toLowerCase())
                    })
                } else {
                    this.filteredPlayerClassList = [...this.custom_player_class_list]
                }
            },

            // 过滤变化事件
            onFilterChange(query) {
                this.filterPlayerClass(query)
            },

            // 歌星分类选择变化事件
            onPlayerClassChange(value) {
                // 检查选择的值是否在有效列表中
                const isValidValue = this.custom_player_class_list.some(item => item.name === value)
                if (value && !isValidValue) {
                    // 如果选择的值不在有效列表中，清空选择
                    this.add_custom_player_szPlayerClass = ''
                    layer.msg('请从现有分类中选择，不能创建新分类')
                }
            },  

			// 获取自定义歌星列表
			getCustomPlayerList(page) {
				const _this = this;

				_this.loading = true;
				_this.custom_player_list_page = page;
				Vue.axios.post('Songs/getCustomSingersList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"szName": _this.custom_player_list_form.szName
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.custom_player_list_total = Number(res.data.response.result.total);
						}
						_this.custom_player_list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 新增自定义歌星
			toAddCustomPlayer() {
				let _this = this
				this.add_custom_player_szName = ''
                this.add_custom_player_szPlayerClass = ''

				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: ['新增歌星', true],
					area: ['550px', ''],
					content: $(_this.$refs.add_singer_pop),
					offset: '100px'
				}, function() {
					if(_this.add_custom_player_szName == '') {
						layer.msg('请输入歌星名称')
						return
					}
					Vue.axios.post('Songs/addCustomSingers', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"szName": _this.add_custom_player_szName,
                                "szPlayerClass": _this.add_custom_player_szPlayerClass
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.closeAll()
							layer.msg('新增成功')
							_this.getCustomPlayerList(1)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
				});
			},

			// 修改自定义歌星
			editCustomPlayer(row) {
				let _this = this
				_this.add_custom_player_szName = row.szName
                _this.add_custom_player_szPlayerClass = row.szPlayerClass
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: ['修改歌星', true],
					area: ['550px', ''],
					content: $(_this.$refs.add_singer_pop),
					offset: '100px'
				}, function() {
					if(_this.add_custom_player_szName == '') {
						layer.msg('请输入歌星名称')
						return
					}
					Vue.axios.post('Songs/editCustomSingers', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"id": row.id,
								"szName": _this.add_custom_player_szName,
                                "szPlayerClass": _this.add_custom_player_szPlayerClass
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.closeAll()
							layer.msg('修改成功')
							_this.getCustomPlayerList(_this.custom_player_list_page)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
				});
			},

			// 删除自定义歌星
			deleteCustomPlayer(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Songs/delCustomSingers', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功')
							_this.getCustomPlayerList(_this.custom_player_list_page)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
				});
			},

			quickAddSinger() {
				let _this = this
				this.add_custom_player_szName = _this.name

				let index =layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: ['新增歌星', true],
					area: ['550px', ''],
					content: $(_this.$refs.add_singer_pop),
					offset: '100px'
				}, function() {
					if(_this.add_custom_player_szName == '') {
						layer.msg('请输入歌星名称')
						return
					}
					Vue.axios.post('Songs/addCustomSingers', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"szName": _this.add_custom_player_szName
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.close(index)
							layer.msg('新增成功')
							_this.getPlayerTable(1)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
				});
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	p {
		line-height: 30px;
		color: #FF0707;
	}

	.add-panel {
		.el-select {
            width: 400px;
        }
        .el-input {
            width: 400px;
        }
        .upload-btn {
        	margin: 0 10px;
        }
		.warm-tip {
			position: absolute;
			left: 550px;
			top: 0;
			width: 440px;
			font-size: 12px;
			color: #FF0707;
			line-height: 18px;
		}
		.rmarkspan {
			float: none;
			margin-left: 10px;
			transform: translateY(10px;);
			display: inline-block;
		}
	}

	.player-panel {
		display: none;
		.inline.center {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
		}

		.search-input {
			margin-right: 20px;
		}

		.el-table {
			margin-top: 20px;
		}
		.cursor-pointer {
			cursor: pointer;
		}

		.text-blue {
			color: #409EFF;
			&:hover {
				opacity: 0.8;
			}
		}
	}
	.add-singer-pop {
		.el-input {
			width: 350px;
		}
	}
</style>